var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDeleteAccountPage = function SvgIconDeleteAccountPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 144,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    x: 0.5,
    fill: "#EDECEC",
    rx: 72
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_delete_account_page_svg__a",
    width: 45,
    height: 44,
    x: 50,
    y: 50,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M50.5 50h44v44h-44z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_delete_account_page_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4F4440",
    d: "M67.733 79.615 72.5 74.85l4.767 4.766 1.931-1.932-4.766-4.766 4.766-4.767-1.931-1.932-4.767 4.767-4.767-4.767-1.931 1.932 4.766 4.767-4.766 4.766zm-3.836 7.968q-1.39 0-2.351-.962-.963-.963-.963-2.352V61H58.75v-2.75H67v-1.622h11v1.622h8.25V61h-1.833v23.27q0 1.389-.963 2.35-.962.963-2.351.963z"
  }))));
};
export default SvgIconDeleteAccountPage;